<div class="wrapper">
  <div>
    <div class="toggle" [style.left]="position+'px'" [style.background-color]="bgColor"></div>
    <div *ngFor="let item of values">
      <input type="radio" [name]="name" [value]="item.value"
             [checked]="item.value == selected">
      <label (click)="setSelected(item.value)" [innerHTML]="item.icon"
             [style.color]="(item.value == selected) ? color:'initial'"></label>
    </div>
  </div>
  <label>{{getLabel()}}</label>
</div>

